import { Injectable } from '@angular/core';
import { Canvas, FabricObject } from 'fabric';
import { ObjectTypeEnum } from '../../_enums/object-type.enum';
import { getMnemonicViewportSceneBounds } from './mnemonic-canvas-bounds.util';

@Injectable({
    providedIn: 'root',
})
export class MnemonicCanvasObjectResolver {
    resolveActiveObject(canvas: Canvas, currentObject: any): FabricObject | undefined {
        const activeObject = canvas.getActiveObject();

        if (activeObject) {
            return activeObject;
        }

        if (!currentObject || currentObject === canvas) {
            return undefined;
        }

        if (currentObject.id) {
            const canvasObject = canvas.getObjects().find((obj: any) => obj.id === currentObject.id);
            if (canvasObject) {
                return canvasObject;
            }
        }

        return typeof currentObject.set === 'function' ? currentObject : undefined;
    }

    isImageObject(object: FabricObject | null | undefined): boolean {
        if (!object) {
            return false;
        }

        const typedObject = object as any;
        return (
            typedObject.type === 'image' ||
            typedObject.objectType === ObjectTypeEnum.image ||
            typedObject.objectType === ObjectTypeEnum.defaultImage
        );
    }

    clampWithinCanvasBounds(target: any): void {
        const canvas = target?.canvas as Canvas | undefined;
        if (!canvas) {
            return;
        }

        const obj = target;
        const viewport = getMnemonicViewportSceneBounds(canvas);

        if (obj.getScaledHeight() > viewport.height || obj.getScaledWidth() > viewport.width) {
            return;
        }

        obj.setCoords();
        const bound = obj.getBoundingRect();

        if (bound.left < viewport.left) {
            obj.left += viewport.left - bound.left;
        }
        if (bound.top < viewport.top) {
            obj.top += viewport.top - bound.top;
        }
        if (bound.left + bound.width > viewport.right) {
            obj.left -= bound.left + bound.width - viewport.right;
        }
        if (bound.top + bound.height > viewport.bottom) {
            obj.top -= bound.top + bound.height - viewport.bottom;
        }

        obj.setCoords();
    }
}
